import '../json-viewer';

describe('json-viewer', () => {
  it('Expect custom element <json-viewer> is defined', () => {
    expect(customElements.get('json-viewer')).toBeDefined();
  });
});
